module.exports = __webpack_public_path__ + "static/media/logo_wecare.fca37f91.png";